import type { EnvironmentType } from '@system-atlas/shared';

/** Farbpaletten zur klaren Unterscheidung Cloud vs. vor Ort (und neutral). */
export const ENV_COLORS: Record<EnvironmentType, { fill: string; stroke: string }> = {
  cloud: { fill: '#dbeafe', stroke: '#2563eb' },
  on_prem: { fill: '#dcfce7', stroke: '#16a34a' },
  neutral: { fill: '#f1f5f9', stroke: '#64748b' },
};

export const GRID_SIZE = 10;
